import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import {
  breakpoint,
  fontSize,
  pxToRem,
  size,
  width,
} from '@twistopayments/design-system/styles'

export const faq = css`
  text-align: center;
  padding-bottom: ${size[20]};

  ${breakpoint.up('md')} {
    margin: ${size[112]} auto;
  }
`

export const headline = css`
  margin-bottom: ${size[40]};
  font-size: ${pxToRem(36)};
  font-weight: 700;

  ${breakpoint.up('smMd')} {
    font-size: ${pxToRem(48)};
    letter-spacing: -1px;
  }
`

export const highlighted = (theme: Theme) => css`
  color: ${theme.palette.secondary.mainContrast};
`

export const description = css`
  font-size: ${pxToRem(24)};
`

export const inner = css`
  margin: 0 auto;
  padding: 0 ${size[20]};
  max-width: ${width.container.large};
`

export const answers = css`
  display: flex;
  flex-direction: column;
  gap: ${size[12]};
  text-align: left;
  margin: ${size[40]} auto 0;
`

export const single = css`
  max-width: 730px;
`

export const double = css`
  ${breakpoint.up('smMd')} {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
`

export const answerItem = (theme: Theme) => css`
  position: relative;
  flex-grow: 1;
  color: ${theme.palette.primary.mainContrast};
  border-radius: ${theme.borderRadius.lg};
  border: 1px solid rgba(66, 10, 135, 0.5);
  padding: ${size[16]};
  height: fit-content;

  & .accordion__item__label {
    font-size: ${pxToRem(22)};
    font-weight: 600;
    line-height: ${size[24]};
    color: ${theme.palette.primary.mainContrast};
  }

  & .accordion__item__panel {
    color: ${theme.palette.text.title};
    font-size: ${pxToRem(20)};
    padding: 0;
  }

  ${breakpoint.up('smMd')} {
    padding: ${size[24]};

    & .accordion__item__label {
      font-size: ${fontSize.smMd};
    }

    & .accotrdion__item__panel {
      font-size: ${fontSize.smMd};
    }
  }
`
